import { axiosInstance } from "../axios_Instanse";
import { axiosInstance_modal } from "../axios_instance_modal";
import {
  getSubOrders,
  setQrCode,
  set_Qr_Loading,
  set_Load_Download,
  set_Refresh,
  set_Let_Refresh,
} from "./OrderActionCreators";
import Store from "../Store";
import fileDownload from "js-file-download";

export const getSubOrder = async (id) => {
  try {
    Store.dispatch(getSubOrders([]));
    const subOrder = await axiosInstance_modal.get(`/order_details/${id}`);
    Store.dispatch(getSubOrders(subOrder.data));
  } catch (error) {}
};

export const downloadAllOrderDetails = async (orderId, rowValue) => {
  const { refresh } = Store.getState().OrderReducer;
  Store.dispatch(
    set_Load_Download({
      all: true,
      single: false,
    })
  );
  Store.dispatch(set_Let_Refresh(true));
  try {
    const file = await axiosInstance_modal.get(`/order_detail/${orderId}`, {
      responseType: "blob",
    });

    Store.dispatch(
      set_Load_Download({
        all: false,
        single: false,
      })
    );
    Store.dispatch(set_Refresh(refresh + 1));
    Store.dispatch(set_Let_Refresh(false));
    fileDownload(file.data, `${rowValue} : سفارش شماره .zip`);
  } catch (error) {}
};
export const downloadSingleOrderFile = async (
  orderId,
  fileId,
  fileName,
  rowValue
) => {
  const { refresh } = Store.getState().OrderReducer;
  Store.dispatch(set_Let_Refresh(true));
  Store.dispatch(
    set_Load_Download({
      all: false,
      single: true,
    })
  );
  try {
    const singlefile = await axiosInstance_modal.get(
      `/order_detail/${orderId}/${fileId}`,
      { responseType: "blob" }
    );
    Store.dispatch(
      set_Load_Download({
        all: false,
        single: false,
      })
    );
    Store.dispatch(set_Refresh(refresh + 1));
    Store.dispatch(set_Let_Refresh(false));
    fileDownload(singlefile.data, `${rowValue}-${fileName}`);
  } catch (error) {}
};

export const changeActiveOrdersState = async (orderStateToChange) => {
  // const { refresh } = Store.getState().OrderReducer;
  try {
    Store.dispatch(set_Qr_Loading(true));
    Store.dispatch(setQrCode(null));
    const qrData = await axiosInstance_modal.get(
      `/order_barcode/${orderStateToChange}`
    );
    // Store.dispatch(set_Refresh(refresh + 1));
    Store.dispatch(set_Qr_Loading(false));
    Store.dispatch(setQrCode(qrData.data));
  } catch (error) {}
};

export const getActive_Ready_Orders = async () => {
  try {
    const Orders = await axiosInstance.get("/publisher_current_orders");

    const activeOrders = Orders.data.active
      .slice()
      .sort((a, b) => new Date(b.cDate) - new Date(a.cDate));
    const ReadyOrders = Orders.data.ready_to_send
      .slice()
      .sort((a, b) => new Date(b.cDate) - new Date(a.cDate));

    localStorage.offline = Orders.data.offline;
    localStorage.last_state = Orders.data.last_state;

    return { activeOrders, ReadyOrders };
  } catch (error) {}
};
